import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Precision from "./sections/Precision";
import Industry from "./sections/Industry";
import Processes from "./sections/Processes";
import Specializations from "./sections/Specializations";
import Advantage from "./sections/Advantage";
import Sales from "./sections/Sales";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Precision />
      <Industry />
      <Processes />
      <Specializations />
      <Advantage />
      <Sales />
      <Footer />
    </div>;
}